/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-image-lightbox/style.css';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import ReactApexChart from 'react-apexcharts';

import { get } from '../../helpers/api_helper';
import { buildComparisonBarOptions } from './chartTheme';

function OrderComparisonChart(props) {
  const { t, date } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [data, setData] = useState(null);
  const [chartOptions, setChartOptions] = useState(null);
  const [chartSeries, setChartSeries] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/api/sales/reports/orders/count?isoDay=${date}`);
        setData(response);
      } catch (error) {
        toastr.error(t('Error fetching order count data'));
      }
    };

    fetchData();
  }, [date]);

  useEffect(() => {
    if (data) {
      const { day_counts, prior_week_day_counts } = data;

      const allSites = [...new Set([...day_counts, ...prior_week_day_counts]
        .map((item) => item.site))];
      const todayCountsMap = Object.fromEntries(day_counts.map((item) => [item.site, item.cnt]));
      const lastWeekCountsMap = Object
        .fromEntries(prior_week_day_counts.map((item) => [item.site, item.cnt]));
      const todayCounts = allSites.map((site) => todayCountsMap[site] || 0);
      const lastWeekCounts = allSites.map((site) => lastWeekCountsMap[site] || 0);
      setChartOptions(buildComparisonBarOptions({
        categories: allSites,
        yTitle: t('Order Count'),
        tooltipFormatter: (val) => `${val} orders`,
        columnWidth: '42%',
        borderRadius: 4,
        showDataLabels: false,
      }));

      setChartSeries([
        {
          name: t('Today'),
          data: todayCounts,
        },
        {
          name: t('Same Time Last Week'),
          data: lastWeekCounts,
        },
      ]);
    }
  }, [data]);

  return (
    <div className="dashboard-chart">
      {chartOptions && chartSeries && (
        <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={360} />
      )}
      {chartOptions === null && (
        <div className="text-center">
          <span className="mdi mdi-loading mdi-spin fs-2" />
        </div>
      )}
    </div>
  );
}

OrderComparisonChart.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  date: PropTypes.string.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(OrderComparisonChart));
